import React, { useState } from 'react';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import BrushRoundedIcon from '@mui/icons-material/BrushRounded';
import ChatBubbleRoundedIcon from '@mui/icons-material/ChatBubbleRounded';
import MicRoundedIcon from '@mui/icons-material/MicRounded';
import PhotoCameraRoundedIcon from '@mui/icons-material/PhotoCameraRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import TheaterComedyRoundedIcon from '@mui/icons-material/TheaterComedyRounded';
import './BrandPalettePreviewPage.css';

const colors = [
  ['Primary action', '#274D3B'],
  ['Button hover', '#1F3D30'],
  ['Leaf accent', '#6F9654'],
  ['Conversation', '#FDFCF8'],
  ['Selected', '#EDF1DF'],
  ['User bubble', '#DCE8C8'],
];

const activities = [
  { icon: <ChatBubbleRoundedIcon />, name: 'Free Talk', note: 'Talk about anything', tone: 'green' },
  { icon: <BrushRoundedIcon />, name: 'Creative Drawing', note: 'Turn ideas into art', tone: 'peach' },
  { icon: <TheaterComedyRoundedIcon />, name: 'Scenario Practice', note: 'Practise everyday moments', tone: 'lime' },
];

export default function BrandPalettePreviewPage() {
  const [palette, setPalette] = useState('refined');
  const activeColors = palette === 'original' ? [
    ['Primary', '#586F3C'], ['Accent', '#6F9B23'], ['Soft', '#DCE8C8'],
    ['Background', '#FDFEFC'], ['Paper', '#F5F8F1'], ['Ink', '#2D3913'],
  ] : colors;

  return (
    <main className={`brand-preview-page palette-${palette}`}>
      <header className="brand-preview-header">
        <a href="/protected"><ArrowBackRoundedIcon /> Back to app</a>
        <div className="brand-preview-logo"><span>M</span> MARSTRIX</div>
        <span className="brand-preview-label">DESIGN PREVIEW</span>
      </header>

      <section className="brand-preview-intro">
        <p>CURRENT APP DESIGN REFERENCE</p>
        <h1>One Marstrix family,<br/><em>clear, warm and consistent.</em></h1>
        <span>This page now mirrors the implemented App colors: white navigation, subtle green selection, warm conversation surfaces, light user bubbles and forest-green actions.</span>
        <div className="brand-palette-toggle" role="group" aria-label="Choose palette preview">
          <button className={palette === 'original' ? 'is-active' : ''} onClick={() => setPalette('original')}>Before tuning</button>
          <button className={palette === 'refined' ? 'is-active' : ''} onClick={() => setPalette('refined')}>Current App</button>
        </div>
      </section>

      <section className="brand-preview-swatches" aria-label="Brand colors">
        {activeColors.map(([name, color]) => (
          <div key={name}>
            <span style={{ background: color }} />
            <strong>{name}</strong>
            <small>{color}</small>
          </div>
        ))}
      </section>

      <section className="brand-app-frame">
        <aside className="brand-app-sidebar">
          <div className="brand-app-mark"><span>M</span><b>MARSTRIX</b></div>
          <nav>
            <button className="is-active"><ChatBubbleRoundedIcon /> Create & Talk</button>
            <button><AutoAwesomeRoundedIcon /> My Stories</button>
            <button><PhotoCameraRoundedIcon /> Photo Story</button>
          </nav>
          <div className="brand-app-buddy"><span>🍃</span><div><b>Leafy</b><small>Your talking buddy</small></div></div>
        </aside>

        <div className="brand-app-content">
          <div className="brand-app-topbar"><div><small>GOOD AFTERNOON</small><h2>What would you like to do?</h2></div><button>Parent settings</button></div>

          <div className="brand-activity-grid">
            {activities.map((activity) => (
              <article className={`brand-activity-card ${activity.tone}`} key={activity.name}>
                <span>{activity.icon}</span><div><h3>{activity.name}</h3><p>{activity.note}</p></div><b>→</b>
              </article>
            ))}
          </div>

          <section className="brand-conversation-card">
            <div className="brand-conversation-head"><div><span>🍃</span><div><b>Talking with Leafy</b><small>Free Talk · Beta</small></div></div><button>•••</button></div>
            <div className="brand-timeline">
              <div className="brand-message leafy">Hi! What made you smile today? <span>😄</span></div>
              <div className="brand-message child">I drew a giant rocket at school!</div>
              <div className="brand-message leafy">A giant rocket sounds brilliant! Where would it fly?</div>
            </div>
            <div className="brand-composer">
              <button aria-label="Add photo"><PhotoCameraRoundedIcon /></button>
              <input aria-label="Message preview" placeholder="Tell Leafy something…" readOnly />
              <button aria-label="Use microphone"><MicRoundedIcon /></button>
              <button className="send" aria-label="Send"><SendRoundedIcon /></button>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}
